<template>
    <b-container>
        <b-tabs v-model="tabIndex" class="worldcup__tabs">
            <template v-for="(tab, index) in tabs">
                <b-tab :key="index"
                       lazy
                       pills
                       :active="tab.isActive"
                       :disabled="tab.isRequiredLogin && !currentUser"
                       @click="changeTab">
                    <template #title>
                        <span>{{ tab.title }}</span>
                    </template>
                    <component :is="tab.component" />
                </b-tab>
            </template>
        </b-tabs>
    </b-container>
</template>
<script>
export default {
    props: {
        tabs: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tabIndex: 0
        };
    },
    watch: {
        $route(route) {
            const { tab } = route.query;
            if (tab) {
                if (tab === 'earnTurn') {
                    this.tabIndex = 1;
                } else {
                    this.tabIndex = 0;
                }
            }
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    },
    methods: {
        changeTab() {
            this.$router.push('/worldcup');
        }
    }
};
</script>
